import { InputType } from "../../../../schemas/schema.types.js";
import { CommonSchemaIds } from "./common.const.js";
export const COMMON_TLMD_SCHEMAS = {
    [CommonSchemaIds.VISIBLE]: {
        id: CommonSchemaIds.VISIBLE,
        schema: {
            type: 'boolean',
            default: 'true'
        },
        enum: [
            { value: false, dictionaryKey: `schema.${CommonSchemaIds.VISIBLE}.options.hidden` },
            { value: true, dictionaryKey: `schema.${CommonSchemaIds.VISIBLE}.options.visible` }
        ],
        input: {
            type: InputType.CheckField,
            properties: {
                transform: 'capitalize'
            }
        }
    },
    [CommonSchemaIds.CHART_TYPE]: {
        id: CommonSchemaIds.CHART_TYPE,
        schema: {
            type: 'string',
            default: 'auto'
        },
        enum: [
            { value: 'auto', dictionaryKey: '`charts.auto' },
            { value: 'pie', dictionaryKey: 'charts.pie' },
            { value: 'hbar', dictionaryKey: 'charts.bar' },
        ],
        input: {
            type: InputType.SelectField,
            properties: {
                transform: 'capitalize'
            }
        }
    },
};
